import { fetchGet } from '../../providers/Fetch';

import { AGENTS_ERROR, AGENTS_REQUEST, AGENTS_SUCCESS } from './types';

export const agentsError = error => ({
  type: AGENTS_ERROR,
  error,
});

export const agentsRequest = {
  type: AGENTS_REQUEST,
};

export const agentsSuccess = data => ({
  type: AGENTS_SUCCESS,
  data,
});

export const agentsFetch = (areas = []) => async (dispatch) => {
  dispatch(agentsRequest);
  const agents = {};
  try {
    await Promise.all(
      areas.map(async (area) => {
        // eslint-disable-next-line no-underscore-dangle
        agents[area.code] = await fetchGet(`/user?area=${area._id}&role=agent`);
      }),
    );
    dispatch(agentsSuccess(agents));
  } catch (e) {
    dispatch(agentsError(e.message));
  }
};
